import React from 'react';

const Mathematics = () => {
    return (
        <div>Mathematics Component</div>
    );
}

export default Mathematics;
